import type { BlockDefinition } from '#layers/block-engine/types/block';
import { getBuiltinBlocks } from '#layers/block-engine/utils/block/builtin-registry';

/**
 * Resolves builtin block definitions from the generated registry without
 * entering the async serialized-block resolution pipeline.
 */
export function resolveBuiltinBlock(blockId: string): BlockDefinition | undefined {
	return getBuiltinBlocks()[blockId];
}
